import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { GoSearch } from 'react-icons/go';
import { Link, Route, Routes, useNavigate } from 'react-router-dom';
import { usePrefersReducedMotion } from '@jokerdad/hooks';
import { dispatchSearchOpened, dispatchVisitingViaUrl, useMainContext } from '@jokerdad/providers';
import { exitAnimation, exitWithoutAnimation } from './utils';

var SearchOpen = function SearchOpen(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(GoSearch, {
    className: "text-white text-6xl",
    onClick: onClick
  });
};

var SearchClose = function SearchClose(_ref2) {
  var onClick = _ref2.onClick;
  return /*#__PURE__*/React.createElement(FaTimes, {
    className: "text-white text-6xl",
    onClick: onClick
  });
};

var SearchToggle = function SearchToggle() {
  var navigate = useNavigate();
  var reducedMotionPreferred = usePrefersReducedMotion();

  var _useMainContext = useMainContext(),
      _useMainContext$ = _useMainContext[0],
      routingDisabled = _useMainContext$.routingDisabled,
      visitingViaUrl = _useMainContext$.visitingViaUrl,
      searchOpened = _useMainContext$.searchOpened,
      dispatch = _useMainContext[1];

  var setVisitingViaUrlToFalse = function setVisitingViaUrlToFalse() {
    visitingViaUrl && dispatchVisitingViaUrl(dispatch, false);
  };

  var handleExitWithAnimation = function handleExitWithAnimation() {
    exitAnimation({
      complete: function complete() {
        setVisitingViaUrlToFalse();
        routingDisabled ? dispatchSearchOpened(dispatch, false) : navigate('/');
      }
    });
  };

  var handleExitWithoutAnimation = function handleExitWithoutAnimation() {
    exitWithoutAnimation();
    routingDisabled ? dispatchSearchOpened(dispatch, false) : navigate('/');
  };

  var handleExit = function handleExit() {
    reducedMotionPreferred ? handleExitWithoutAnimation() : handleExitWithAnimation();
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "w-[7rem] h-[7rem] flex items-center justify-center absolute top-0 right-0 mt-8 mr-8 z-20 bg-secondary rounded-full cursor-pointer"
  }, !routingDisabled && /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/",
    element: /*#__PURE__*/React.createElement(Link, {
      to: "/search"
    }, /*#__PURE__*/React.createElement(GoSearch, {
      className: "text-white text-6xl",
      onClick: setVisitingViaUrlToFalse
    }))
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/search",
    element: /*#__PURE__*/React.createElement(FaTimes, {
      onClick: handleExit,
      className: "text-white text-6xl"
    })
  })), routingDisabled && (searchOpened ? /*#__PURE__*/React.createElement(SearchClose, {
    onClick: handleExit
  }) : /*#__PURE__*/React.createElement(SearchOpen, {
    onClick: function onClick() {
      dispatchSearchOpened(dispatch, true);
      setVisitingViaUrlToFalse();
    }
  })));
};

export default SearchToggle;